/**
 * Format helpers and category metadata used across the app.
 *
 * NOTE: This file was historically named `mock-data.ts` because it once held
 * mock data. All mock data has been removed; only formatting helpers and the
 * category list (which is authoritative for event categorization) remain.
 *
 * Kept under the same filename to avoid a noisy rename across 10+ imports.
 * Treat it as `src/lib/format.ts`.
 */

export const categories: string[] = [
  "Música",
  "Deportes",
  "Teatro",
  "Comedia",
  "Conferencias",
  "Festivales",
  "Otros",
];

/**
 * Format a numeric amount as a CRC price with thousands separator.
 * Currency is hardcoded to CRC because the platform is CR-only today.
 */
export function formatPrice(amount: number | string | null | undefined): string {
  const n = Number(amount ?? 0);
  if (!Number.isFinite(n)) return "₡0";
  return `₡${Math.round(n).toLocaleString("es-CR")}`;
}

/**
 * Format an event date (YYYY-MM-DD or ISO) as a long human-readable Spanish date.
 */
export function formatDate(date: string | Date | null | undefined): string {
  if (!date) return "";
  const d = typeof date === "string" ? new Date(date.includes("T") ? date : `${date}T00:00:00`) : date;
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString("es-CR", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}
